import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class AuthInterceptorExclusionService {
  private unprotectedUrls = new Set<string>();
  private unprotectedPatterns = new Set<string>();

  markAsUnprotected(url: string): void {
    this.unprotectedUrls.add(url);
  }

  addUnprotectedPattern(pattern: string): void {
    this.unprotectedPatterns.add(pattern);
  }

  shouldSkipAuth(url: string): boolean {
    return (
      this.unprotectedUrls.has(url) ||
      Array.from(this.unprotectedPatterns).some((pattern) => url.includes(pattern))
    );
  }
}
